import Swiper from 'swiper/js/swiper';
import { Component } from '@verndale/core';

import breakpoints from '../utils/breakpoints';
import { getGenericSliderConfig } from '../utils/slider';

class QuTodayRelatedArticles extends Component {
  setupDefaults() {
    this.dom = {
      $heading: this.el._$('h2'),
      $slides: this.el._$$('.swiper-slide'),
      $swiperContainer: this.el._$('.swiper-container')
    };

    this.isInWrapper = this.el.closest('.big-wrapper') ? true : false;
    this.el.dataset.isInWrapper = this.isInWrapper;

    if (!this.isInWrapper) {
      this.isInProfileDetail = this.el.closest('.wrapper--profile-detail')
        ? true
        : false;

      this.el.dataset.isInWrapper = this.isInProfileDetail;
    }

    this.el.dataset.slides =
      this.dom.$slides.length >= 3 ? 3 : this.dom.$slides.length;
    this.initSlider();
  }

  initSlider() {
    const { $swiperContainer, $slides, $heading } = this.dom;
    const { length } = $slides;

    const getTabletSlides = () => {
      if (length < 2) {
        return 1;
      }

      if (length === 2) {
        return 2;
      }

      return this.isInWrapper ? 2 : Math.min(3, length);
    };

    const getDesktopSlides = () => {
      if (length < 2) {
        return 1;
      }

      return this.isInWrapper ? 2 : Math.min(3, length);
    };

    const element = this.el;

    this.swiper = new Swiper($swiperContainer, {
      ...getGenericSliderConfig(element, $heading),
      slidesPerView: 1,
      spaceBetween: 20,
      breakpoints: {
        [breakpoints.tablet]: {
          slidesPerView: getTabletSlides(),
          spaceBetween: 26
        },
        [breakpoints.lg]: {
          slideToClickedSlide: false,
          slidesPerView: getDesktopSlides(),
          spaceBetween: length === 2 && !this.isInWrapper ? 62 : 32,
          centeredSlides: length === 1
        }
      },
      on: {
        init() {
          $swiperContainer.classList.remove('loading');
          $swiperContainer.classList.add('loaded');
        }
      }
    });
  }
}

export default QuTodayRelatedArticles;
